import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { styled, useTheme } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import { DashboardEventT } from './type';

const StyPaper = styled(Paper, {
    name: 'StyPaper',
})({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'space-between',
});

function DashboardEventContent({
    content,
}: Pick<DashboardEventT, 'content'>): React.ReactElement {
    const theme = useTheme();
    const { t } = useTranslation();
    if (!content) return <></>;
    return (
        <StyPaper
            variant="outlined"
            sx={{ padding: theme.spacing(1), margin: theme.spacing(1) }}
        >
            {content.modifiedRights && (
                <Typography>
                    <Trans
                        i18nKey="dashboardHistory.modifiedRights"
                        components={{ bold: <strong /> }}
                        values={{
                            rights: content.modifiedRights
                                .map(
                                    ({ name, accessLevel }) =>
                                        `${name} (${t(`dashboardHistory.accessLevel.${accessLevel}`)})`,
                                )
                                .join(', '),
                        }}
                    />
                </Typography>
            )}
            {content.organizationShare && (
                <Typography>
                    <Trans
                        i18nKey="dashboardHistory.organizationShare"
                        components={{ bold: <strong /> }}
                        values={{
                            accessLevel: t(
                                `dashboardHistory.accessLevel.${content.organizationShare}`,
                            ),
                        }}
                    />
                </Typography>
            )}
            {content.publicShare !== undefined && (
                <Typography>
                    <Trans
                        i18nKey="dashboardHistory.publicShare"
                        components={{ bold: <strong /> }}
                        values={{ status: t(`common.${content.publicShare}`) }}
                    />
                </Typography>
            )}
        </StyPaper>
    );
}
export default DashboardEventContent;
